import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../../utils/url-utils';
import { setFormDataV2 } from '../../../utils/network-utils';
import { errorHandl } from '../../../utils/network-utils';
@Injectable({
  providedIn: 'root'
})
export class StaffService {
  public KEY_TOKEN: 'token';
  constructor(private http: HttpClient) {
  }

  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };


  getStaffList(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.STAFF_URL)
      .pipe(
        catchError(errorHandl)
      );
  }

  getStaffById(id): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.STAFF_URL + '/' + id)
      .pipe(
        catchError(errorHandl)
      );
  }

  saveStaff(staffData: any): Observable<any> {
    const { images, staffId, ...rest } = (staffData || {}) as any;
    const newProfilePicture = images && images.newProfilePicture;

    const formData = setFormDataV2({
      ...rest,
      ...(newProfilePicture ? { newProfilePicture } : {}),
    }, 'staff');

    if (staffId) {
      return this.http.put<any>(urls.BASE_URL + urls.STAFF_URL + '/' + staffId, formData).pipe(
        catchError(errorHandl)
      );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.STAFF_URL, formData).pipe(
        catchError(errorHandl)
      );
    }
  }

  getStaffTimelines(queryString: any): Observable<any> {
    let endpoint = '/current';
    if (queryString && queryString.dates) {
      endpoint = '';
    }

    let query = '?staff=' + queryString.staff;
    if (queryString.dates) {
      query = query + '&dates=' + encodeURI(JSON.stringify(queryString.dates));
    }

    return this.http.get<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL + endpoint + query)
      .pipe(
        catchError(errorHandl)
      );
  }

  getAllStaffTimelines(queryString: any): Observable<any> {
    let query = '';
    if (queryString && queryString.dates) {
      query = '?dates=' + encodeURI(JSON.stringify(queryString.dates));
    }

    return this.http.get<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL + query)
      .pipe(
        catchError(errorHandl)
      );
  }

  getTimelinesByDate(date: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('startDate', date);

    return this.http.get<any>(urls.BASE_URL + urls.STAFF_TIMELINES_DASHBOARD_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  postStaffTimeline(payload: any): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  saveStaffBreak(payload: any): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getStaffTimelineById(id: string): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL + '/' + id)
      .pipe(
        catchError(errorHandl)
      );
  }

  deleteStaffTimelineById(id: string): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL + '/' + id, {})
      .pipe(
        catchError(errorHandl)
      );
  }

  saveStaffTimeline(payload: any): Observable<any> {
    if (payload._id) {
      return this.http.put<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL + '/' + payload._id, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  saveStaffBreakTimeline(payload: any): Observable<any> {
    if (payload._id) {
      return this.http.put<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL + '/' + payload._id, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getStaffTimelinesReport(queryString: any): Observable<any> {
    let query = '?dates=' + encodeURI(JSON.stringify(queryString.dates)) + '&isReport=true';
    if (queryString.staff) {
      query = query + '&staff=' + queryString.staff;
    }

    return this.http.get<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL + query)
      .pipe(
        catchError(errorHandl)
      );
  }

  getStaffTimeline(query: string = ''): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.STAFF_TIMELINES_URL + "/current" + query).pipe(
      catchError(errorHandl)
    );
  }

  addShiftOverride(data: any, id): Observable<any> {
    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.STAFF_SHIFTS + '/' + id, data)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.STAFF_SHIFTS, data)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getShiftOverridesByDate(payload): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.STAFF_SHIFTS + '/bydate', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getShiftOverrideById(shiftId): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.STAFF_SHIFTS + '/' + shiftId)
      .pipe(
        catchError(errorHandl)
      );
  }

  deleteShiftOverride(shiftId): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.STAFF_SHIFTS + '/' + shiftId, {})
      .pipe(
        catchError(errorHandl)
      );
  }

  updateShiftOverrideApproval(shiftId, approvalStatus): Observable<any> {
    return this.http.put<any>(urls.BASE_URL + urls.STAFF_SHIFTS + '/' + shiftId + '/approval', { approvalStatus })
      .pipe(
        catchError(errorHandl)
      );
  }
}
